import React, { Component } from 'react';
import PropTypes from 'prop-types';

class APICellRenderer extends Component {
  renderContent() {
    const { value } = this.props;
    if (value && value !== null) {
      return (<code>{value}</code>);
    }
    return null;
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

APICellRenderer.propTypes = {
  value: PropTypes.string,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
};
APICellRenderer.defaultProps = {
  value: null,
};

export default APICellRenderer;
